import { useState, useCallback } from 'react';
import type { UseConfirmationDialogState } from './types';

export const useConfirmationDialog = () => {
  const [state, setState] = useState<UseConfirmationDialogState>({
    isOpen: false,
    isConfirming: false
  });

  const open = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: true }));
  }, []);

  const close = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: false, isConfirming: false }));
  }, []);

  const setConfirming = useCallback((isConfirming: boolean) => {
    setState((prev) => ({ ...prev, isConfirming }));
  }, []);

  return {
    // State
    isOpen: state.isOpen,
    isConfirming: state.isConfirming,

    // Actions
    open,
    close,
    setConfirming
  };
};
